import React, { FC, SyntheticEvent } from 'react';
import { useHistory } from 'react-router-dom';
import { RelationshipsLinkFragment } from '../../graphql/__generated__/types';
import { getPathName } from '../../utils/common';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkLayoutFlex } from 'uitk-react-layout-flex';
import { UitkLink } from 'uitk-react-link';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';

interface Props {
  link: RelationshipsLinkFragment;
  alignment: 'left' | 'right';
}

const NavigatorLink: FC<Props> = ({ link, alignment }) => {
  const { push } = useHistory();

  const documentLink = link?.action.resource.value;

  const onClickHandler = (e: SyntheticEvent) => {
    e.preventDefault();

    push(getPathName(documentLink));
  };
  return (
    <UitkLink size="large" align={alignment} className="documentation-name">
      <a href={documentLink} onClick={onClickHandler}>
        <div>
          <UitkLayoutFlex style={{ cursor: 'pointer' }} direction={alignment === 'left' ? 'row-reverse' : 'row'}>
            <UitkLayoutFlex>
              <UitkSpacing
                padding={alignment === 'right' ? { inlineend: 'two' } : { inlinestart: 'two' }}
                border={[alignment === 'right' ? 'inlineend' : 'inlinestart']}
              >
                <div>
                  <UitkText align={alignment} weight="regular">
                    {link.icon.title}
                  </UitkText>

                  <UitkText className="navigation-item-word">{link.text}</UitkText>
                </div>
              </UitkSpacing>
            </UitkLayoutFlex>
            <UitkLayoutFlex alignItems="center">
              <div>
                <UitkIcon
                  theme="default"
                  id={link.icon.title}
                  title={link.icon.title}
                  description={link.icon.description}
                  name={link.icon.token}
                  size={UitkIconSize.LARGE}
                />
              </div>
            </UitkLayoutFlex>
          </UitkLayoutFlex>
        </div>
      </a>
    </UitkLink>
  );
};

export default NavigatorLink;
